<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.tabfre_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Rotas
              <i class="fa fa-map-marker"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.tabfre_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.tabela_frete_modal.length > 0"
          >
            <span class="nav-link-in">
              Modais
              <i class="fa fa-train"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.tabfre_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.tabela_frete_pessoa.length > 0"
          >
            <span class="nav-link-in">
              Clientes
              <i class="fa fa-users"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              v-bind:href="'#t4' + rowData.tabfre_id + ''"
              role="tab"
              data-toggle="tab"
              v-if="rowData.tabela_frete_transportador.length > 0"
          >
            <span class="nav-link-in">
              Transportadores
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.tabfre_id + ''"
          v-if="rowData.tabela_frete_rota.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 40%">Origem</th>
                <th style="width: 40%">Destino</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.tabela_frete_rota">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="item.municipio_origem !== null">{{
                    item.municipio_origem.nome
                  }} - {{ item.municipio_origem.uf.cd }}</span>
                  <span v-if="item.regiao_origem !== null">{{
                    item.regiao_origem.descr
                  }}</span>
                </td>
                <td>
                  <span v-if="item.municipio_destino !== null">{{
                    item.municipio_destino.nome
                  }} - {{ item.municipio_destino.uf.cd }}</span>
                  <span v-if="item.regiao_destino !== null">{{
                    item.regiao_destino.descr
                  }}</span>
                </td>
                <td>
                  <span
                    v-if="item.status.valor == 1"
                    class="badge badge-success"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    v-if="item.status.valor == 2"
                    class="badge badge-danger"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a @click="onEditRota(rowData, item)" v-if="getPermission('tabelafrete.rota.update')" v-b-tooltip title="Editar"><i class="fa fa-edit"></i></a>
                  <a
                    @click="onDetailRota(item.tabfrerot_id)"
                    v-b-tooltip
                    title="Ver detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetailRowRota(item.tabfrerot_id)">
                <td colspan="9">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="'#rot1' + item.tabfrerot_id + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Vigência
                            <i class="fa fa-map-marker"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#rot2' + item.tabfrerot_id + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Carga
                            <i class="fa fa-map-marker"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#rot3' + item.tabfrerot_id + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Meios de Transp.
                            <i class="fa fa-ship"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#rot4' + item.tabfrerot_id + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Caracteristicas
                            <i class="fa fa-info"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="
                          tab-pane
                          fade
                          in
                          active
                          show
                          pt-1
                          border-color-detalhes-grey
                        "
                        v-bind:id="'rot1' + item.tabfrerot_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 5%">
                                <a
                                  v-if="getPermission('tabelafrete.aprovar')"
                                  @click="onAprova(vigenciaSelected)"
                                  v-b-tooltip
                                  title="Aprovar"
                                  ><i class="fa fa-check"></i
                                ></a>
                                <a
                                  v-if="getPermission('tabelafrete.cancelar')"
                                  @click="onCancela(vigenciaSelected)"
                                  v-b-tooltip
                                  title="Cancelar"
                                  ><i class="fa fa-times"></i
                                ></a>
                              </th>
                              <th style="width: 30%">Data início</th>
                              <th style="width: 25%">Data fim</th>
                              <th style="width: 10%">Status</th>
                              <th style="width: 10%">Ações</th>
                            </tr>
                          </thead>
                          <tbody v-for="item_vig in item.tabela_frete_rota_vig">
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <b-form-checkbox
                                  v-model="vigenciaSelected"
                                  :name="'id' + item_vig.tabfrerotvig_id"
                                  :value="item_vig.tabfrerotvig_id"
                                  :disabled="item_vig.status.valor == 3"
                                  unchecked-value="0"
                                >
                                </b-form-checkbox>
                              </td>
                              <td>
                                {{ formatDate(item_vig.dt_vigencia_ini) }}
                              </td>
                              <td>
                                {{ formatDate(item_vig.dt_vigencia_fim) }}
                              </td>
                              <td>
                                <span
                                  class="badge badge-warning"
                                  v-if="item_vig.status.valor == 1"
                                  >{{ item_vig.status.descr }}</span
                                >
                                <span
                                  v-b-tooltip
                                  :title="
                                    'Aprovado por ' +
                                    item_vig.usuario_aprov.pessoa.pessoa_fisica
                                      .nome +
                                    ' em : ' +
                                    formatDate(item_vig.dt_aprovacao)
                                  "
                                  class="badge badge-success"
                                  v-if="item_vig.status.valor == 2"
                                  >{{ item_vig.status.descr }}</span
                                >
                                <span
                                  v-b-tooltip
                                  :title="
                                    'Cancelado por ' +
                                    item_vig.usuario_canc.pessoa.pessoa_fisica
                                      .nome +
                                    ' em : ' +
                                    formatDate(item_vig.dt_canc)
                                  "
                                  class="badge badge-danger"
                                  v-if="item_vig.status.valor == 3"
                                  >{{ item_vig.status.descr }}</span
                                >
                              </td>
                              <td>
                                <a
                                  v-if="
                                    item_vig.status.valor == 1 &&
                                    getPermission('tabelafrete.aprovar')
                                  "
                                  @click="onAprova(item_vig.tabfrerotvig_id)"
                                  v-b-tooltip
                                  title="Aprovar"
                                  ><i class="fa fa-check"></i
                                ></a>
                                <a
                                  v-if="
                                    item_vig.status.valor == 2 &&
                                    getPermission('tabelafrete.cancelar')
                                  "
                                  @click="onCancela(item_vig.tabfrerotvig_id)"
                                  v-b-tooltip
                                  title="Cancelar"
                                  ><i class="fa fa-times"></i
                                ></a>
                                <a
                                  @click="
                                    onDetailVigencia(item_vig.tabfrerotvig_id)
                                  "
                                  v-b-tooltip
                                  title="Ver detalhes"
                                  ><i class="fa fa-plus"></i
                                ></a>
                              </td>
                            </tr>
                            <tr
                              v-if="
                                isVisibleDetailRowVigencia(
                                  item_vig.tabfrerotvig_id
                                )
                              "
                            >
                              <td colspan="10">
                                <section class="tabs-section">
                                  <ul
                                    class="
                                      nav nav-tabs nav-topline nav-justified
                                    "
                                    role="tablist"
                                  >
                                    <li class="nav-item">
                                      <a
                                        class="nav-link active"
                                        v-bind:href="
                                          '#vig1' +
                                          item_vig.tabfrerotvig_id +
                                          ''
                                        "
                                        role="tab"
                                        data-toggle="tab"
                                      >
                                        <span class="nav-link-in">
                                          Cálculos
                                          <i class="fa fa-money"></i>
                                        </span>
                                      </a>
                                    </li>
                                    <li class="nav-item">
                                      <a
                                        class="nav-link"
                                        v-bind:href="
                                          '#vig2' +
                                          item_vig.tabfrerotvig_id +
                                          ''
                                        "
                                        role="tab"
                                        data-toggle="tab"
                                      >
                                        <span class="nav-link-in">
                                          Taxas
                                          <i class="fa fa-money"></i>
                                        </span>
                                      </a>
                                    </li>
                                    <li class="nav-item">
                                      <a
                                        class="nav-link"
                                        v-bind:href="
                                          '#vig3' +
                                          item_vig.tabfrerotvig_id +
                                          ''
                                        "
                                        role="tab"
                                        data-toggle="tab"
                                        v-if="
                                          item_vig.tabela_frete_rota_vig_cus_ext
                                            .length > 0
                                        "
                                      >
                                        <span class="nav-link-in">
                                          Custos
                                          <i class="fa fa-money"></i>
                                        </span>
                                      </a>
                                    </li>
                                  </ul>
                                  <div class="tab-content">
                                    <div
                                      role="tabpanel"
                                      class="
                                        tab-pane
                                        fade
                                        in
                                        active
                                        show
                                        pt-1
                                        border-color-detalhes-grey
                                      "
                                      v-bind:id="
                                        'vig1' + item_vig.tabfrerotvig_id + ''
                                      "
                                    >
                                      <table
                                        :class="[
                                          'vuetable table table-striped tbl-typical',
                                        ]"
                                      >
                                        <thead>
                                          <tr>
                                            <th style="width: 30%">Vlr. ini</th>
                                            <th style="width: 30%">Vlr. fim</th>
                                            <th style="width: 10%">Vlr.</th>
                                            <th style="width: 10%">
                                              Vlr. excedente
                                            </th>
                                            <th style="width: 10%">
                                              Fator Conv.
                                            </th>
                                            <th style="width: 10%">Fixa</th>
                                            <th style="width: 10%">
                                              Excedente
                                            </th>
                                            <th style="width: 5%">Status</th>
                                            <th style="width: 5%">Ações</th>
                                          </tr>
                                        </thead>
                                        <tbody
                                          v-for="item_vig_calc in item_vig.tabela_frete_rota_vig_calc"
                                        >
                                          <tr
                                            class="bg-gray-light"
                                            style="display: table-row"
                                          >
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig_calc.vlr_ini
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig_calc.vlr_fim
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(item_vig_calc.vlr)
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig_calc.vlr_exd
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig_calc.fator_conv
                                                )
                                              }}
                                            </td>
                                            <td>
                                              <span
                                                class="badge badge-success"
                                                v-if="item_vig_calc.fixa == 1"
                                                >Sim</span
                                              >
                                              <span
                                                class="badge badge-danger"
                                                v-if="item_vig_calc.fixa == 0"
                                                >Não</span
                                              >
                                            </td>
                                            <span
                                              class="badge badge-success"
                                              v-if="
                                                item_vig_calc.excedente == 1
                                              "
                                              >Sim</span
                                            >
                                            <span
                                              class="badge badge-danger"
                                              v-if="
                                                item_vig_calc.excedente == 0
                                              "
                                              >Não</span
                                            >
                                            <td>
                                              <span
                                                class="badge badge-success"
                                                v-if="
                                                  item_vig_calc.status.valor ==
                                                  1
                                                "
                                                >{{
                                                  item_vig_calc.status.descr
                                                }}</span
                                              >
                                              <span
                                                class="badge badge-danger"
                                                v-if="
                                                  item_vig_calc.status.valor ==
                                                  2
                                                "
                                                >{{
                                                  item_vig_calc.status.descr
                                                }}</span
                                              >
                                            </td>
                                            <td>
                                              <a v-b-tooltip title="routee"
                                                ><i class="fa fa-plus"></i
                                              ></a>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <div
                                      role="tabpanel"
                                      class="
                                        tab-pane
                                        fade
                                        in
                                        pt-1
                                        border-color-detalhes-grey
                                      "
                                      v-bind:id="
                                        'vig2' + item_vig.tabfrerotvig_id + ''
                                      "
                                    >
                                      <table
                                        :class="[
                                          'vuetable table table-striped tbl-typical',
                                        ]"
                                      >
                                        <thead>
                                          <tr>
                                            <th style="width: 34%">
                                              Tipo taxa TDE
                                            </th>
                                            <th style="width: 33%">Taxa TDE</th>
                                            <th style="width: 33%">
                                              Valor fixo TDE
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            class="bg-gray-light"
                                            style="display: table-row"
                                          >
                                            <td>
                                              {{
                                                item_vig
                                                  .tabela_frete_rota_vig_taxa
                                                  .tp_taxa_tde.descr
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .taxa_tde
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_fixo_tde
                                                )
                                              }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <table
                                        :class="[
                                          'vuetable table table-striped tbl-typical',
                                        ]"
                                      >
                                        <thead>
                                          <tr>
                                            <th style="width: 34%">
                                              Tipo taxa pedágio
                                            </th>
                                            <th style="width: 33%">
                                              Taxa pedágio
                                            </th>
                                            <th style="width: 33%">
                                              Valor pedágio
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            class="bg-gray-light"
                                            style="display: table-row"
                                          >
                                            <td>
                                              {{
                                                item_vig
                                                  .tabela_frete_rota_vig_taxa
                                                  .tp_taxa_pedagio.descr
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .taxa_pedagio
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_pedagio
                                                )
                                              }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <table
                                        :class="[
                                          'vuetable table table-striped tbl-typical',
                                        ]"
                                      >
                                        <thead>
                                          <tr>
                                            <th style="width: 20%">
                                              Taxa GRIS
                                            </th>
                                            <th style="width: 20%">
                                              Taxa Devolução
                                            </th>
                                            <th style="width: 20%">
                                              Taxa Reentrega
                                            </th>
                                            <th style="width: 20%">
                                              Valor Minimo da Nota ou CTe
                                            </th>
                                            <th style="width: 20%">Taxa TDA</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            class="bg-gray-light"
                                            style="display: table-row"
                                          >
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .taxa_gris
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .taxa_devolucao
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .taxa_reentrega
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_min_nota_cte
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .taxa_tda
                                                )
                                              }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <table
                                        :class="[
                                          'vuetable table table-striped tbl-typical',
                                        ]"
                                      >
                                        <thead>
                                          <tr>
                                            <th style="width: 20%">
                                              Valor TAS
                                            </th>
                                            <th style="width: 20%">
                                              Valor Despacho
                                            </th>
                                            <th style="width: 20%">
                                              Valor Sec
                                            </th>
                                            <th style="width: 20%">
                                              Valor agendamento
                                            </th>
                                            <th style="width: 10%">
                                              Valor outros
                                            </th>
                                            <th style="width: 10%">
                                              AD Valorem
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            class="bg-gray-light"
                                            style="display: table-row"
                                          >
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_tas
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_despacho
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_sec_cat
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_agendamento
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .vlr_outros
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .ad_valorem
                                                )
                                              }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <table
                                        :class="[
                                          'vuetable table table-striped tbl-typical',
                                        ]"
                                      >
                                        <thead>
                                          <tr>
                                            <th style="width: 90%">
                                              Observação
                                            </th>
                                            <th style="width: 10%">Status</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            class="bg-gray-light"
                                            style="display: table-row"
                                          >
                                            <td>
                                              {{
                                                item_vig
                                                  .tabela_frete_rota_vig_taxa
                                                  .obs
                                              }}
                                            </td>
                                            <td>
                                              <span
                                                v-if="
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .status.valor == 1
                                                "
                                                class="badge badge-success"
                                                >{{
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .status.descr
                                                }}</span
                                              >
                                              <span
                                                v-if="
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .status.valor == 2
                                                "
                                                class="badge badge-danger"
                                                >{{
                                                  item_vig
                                                    .tabela_frete_rota_vig_taxa
                                                    .status.descr
                                                }}</span
                                              >
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <div
                                      role="tabpanel"
                                      class="
                                        tab-pane
                                        fade
                                        in
                                        pt-1
                                        border-color-detalhes-grey
                                      "
                                      v-bind:id="
                                        'vig3' + item_vig.tabfrerotvig_id + ''
                                      "
                                      v-if="
                                        item_vig.tabela_frete_rota_vig_cus_ext
                                          .length > 0
                                      "
                                    >
                                      <table
                                        :class="[
                                          'vuetable table table-striped tbl-typical',
                                        ]"
                                      >
                                        <thead>
                                          <tr>
                                            <th style="width: 25%">
                                              Tipo trecho
                                            </th>
                                            <th style="width: 25%">
                                              Tipo trecho custo
                                            </th>
                                            <th style="width: 25%">Taxa</th>
                                            <th style="width: 25%">
                                              Taxa comissão
                                            </th>
                                            <th style="width: 25%">
                                              Valor minimo
                                            </th>
                                            <th style="width: 25%">Custo</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr
                                            class="bg-gray-light"
                                            style="display: table-row"
                                            v-for="item_cus_ext in item_vig.tabela_frete_rota_vig_cus_ext"
                                          >
                                            <td>
                                              {{ item_cus_ext.tp_trecho.descr }}
                                            </td>
                                            <td>
                                              {{
                                                item_cus_ext.tp_trecho_custo
                                                  .descr
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_cus_ext.vlr_taxa
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_cus_ext.taxa_comissao
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{
                                                formatNumber(
                                                  item_cus_ext.vlr_minimo
                                                )
                                              }}
                                            </td>
                                            <td>
                                              {{ item_cus_ext.custo.descr }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </section>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'rot2' + item.tabfrerot_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 33%">Tipo carga</th>
                              <th style="width: 34%">Tipo</th>
                              <th style="width: 33%">Status</th>
                            </tr>
                          </thead>
                          <tbody v-for="item in item.tabela_frete_rota_carga">
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item.param_tipo_carga.descr }}
                              </td>
                              <td>
                                {{ item.tp_carga.descr }}
                              </td>
                              <td>
                                <span
                                  v-if="item.status.valor == 1"
                                  class="badge badge-success"
                                  >{{ item.status.descr }}</span
                                >
                                <span
                                  v-if="item.status.valor == 2"
                                  class="badge badge-danger"
                                  >{{ item.status.descr }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'rot3' + item.tabfrerot_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 30%">Tipo Rodado</th>
                              <th style="width: 30%">Carroceria</th>
                              <th style="width: 15%">Carga Perigosa ?</th>
                              <th style="width: 15%">Refrigerado ?</th>
                              <th style="width: 10%">Status</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="item in item.tabela_frete_rota_meio_transp"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item.param_tipo_rodado.descr }}
                              </td>
                              <td>
                                {{ item.param_tipo_carroceria.descr }}
                              </td>
                              <td>
                                <span
                                  v-if="item.carga_perigosa.valor == 1"
                                  class="badge badge-success"
                                  >{{ item.carga_perigosa.descr }}</span
                                >
                                <span
                                  v-if="item.carga_perigosa.valor == 2"
                                  class="badge badge-danger"
                                  >{{ item.carga_perigosa.descr }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="item.refrigerado.valor == 1"
                                  class="badge badge-success"
                                  >{{ item.refrigerado.descr }}</span
                                >
                                <span
                                  v-if="item.refrigerado.valor == 2"
                                  class="badge badge-danger"
                                  >{{ item.refrigerado.descr }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="item.status.valor == 1"
                                  class="badge badge-success"
                                  >{{ item.status.descr }}</span
                                >
                                <span
                                  v-if="item.status.valor == 2"
                                  class="badge badge-danger"
                                  >{{ item.status.descr }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'rot4' + item.tabfrerot_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 30%">Tipo de Operação</th>
                              <th style="width: 30%">Tipo de Processo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item.tp_operacao.descr }}
                              </td>
                              <td>
                                {{ item.tp_processo.descr }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.tabfre_id + ''"
          v-if="rowData.tabela_frete_modal.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Modal</th>
                <th style="width: 50%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.tabela_frete_modal"
              >
                <td>
                  {{ item.b_modal.descr }}
                </td>
                <td>
                  <span
                    v-if="item.status.valor == 1"
                    class="badge badge-success"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    v-if="item.status.valor == 2"
                    class="badge badge-danger"
                    >{{ item.status.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.tabfre_id + ''"
          v-if="rowData.tabela_frete_pessoa.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 70%">Cliente</th>
                <th style="width: 30%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.tabela_frete_pessoa"
              >
                <td>
                  <span v-if="item.pessoa.pessoa_fisica !== null"
                    >{{ item.pessoa.pessoa_fisica.nome }} -
                    {{ item.pessoa.pessoa_fisica.cpf }}</span
                  >
                  <span v-if="item.pessoa.pessoa_juridica !== null"
                    >{{ item.pessoa.pessoa_juridica.razao_social }} CNPJ:
                    {{
                      onFormataCnpj(
                        item.pessoa.pessoa_juridica.cnpj_base,
                        item.pessoa.pessoa_juridica.cnpj_filial,
                        item.pessoa.pessoa_juridica.cnpj_digito
                      )
                    }}
                    IE:
                    {{ item.pessoa.pessoa_juridica.inscricao_estadual }}</span
                  >
                  <span v-if="item.pessoa.pessoa_exterior !== null"
                    >{{ item.pessoa.pessoa_exterior.nome }} -
                    {{ item.pessoa.pessoa_exterior.cd }}</span
                  >
                </td>
                <td>
                  <span
                    v-if="item.status.valor == 1"
                    class="badge badge-success"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    v-if="item.status.valor == 2"
                    class="badge badge-danger"
                    >{{ item.status.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
            role="tabpanel"
            class="tab-pane fade pt-1 border-color-detalhes-grey"
            v-bind:id="'t4' + rowData.tabfre_id + ''"
            v-if="rowData.tabela_frete_transportador.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th style="width: 60%">Transportador</th>
              <th style="width: 20%">Status</th>
              <th style="width: 20%">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.tabela_frete_transportador"
            >
              <td>
                  <span v-if="item.pessoa.pessoa_fisica !== null"
                  >{{ item.pessoa.pessoa_fisica.nome }} -
                    {{ item.pessoa.pessoa_fisica.cpf }}</span
                  >
                <span v-if="item.pessoa.pessoa_juridica !== null"
                >{{ item.pessoa.pessoa_juridica.razao_social }} CNPJ:
                    {{
                    onFormataCnpj(
                        item.pessoa.pessoa_juridica.cnpj_base,
                        item.pessoa.pessoa_juridica.cnpj_filial,
                        item.pessoa.pessoa_juridica.cnpj_digito
                    )
                  }}
                    IE:
                    {{ item.pessoa.pessoa_juridica.inscricao_estadual }}</span
                >
                <span v-if="item.pessoa.pessoa_exterior !== null"
                >{{ item.pessoa.pessoa_exterior.nome }} -
                    {{ item.pessoa.pessoa_exterior.cd }}</span
                >
              </td>
              <td>
                  <span
                      v-if="item.status.valor == 1"
                      class="badge badge-success"
                  >{{ item.status.descr }}</span
                  >
                <span
                    v-if="item.status.valor == 2"
                    class="badge badge-danger"
                >{{ item.status.descr }}</span
                >
              </td>
              <td>
                  <a
                    v-if="item.status.valor == 2"
                    @click="
                      onActivateDesactivateTransp(1, item, true)
                    "
                    v-b-tooltip
                    title="Ativar"
                    ><i class="fa fa-thumbs-o-up"></i
                  ></a>
                  <a
                    v-if="item.status.valor == 1"
                    @click="
                      onActivateDesactivateTransp(2, item, true)
                    "
                    v-b-tooltip
                    title="Inativar"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <TabelaFreteRotaModal ref="tabelafreterotamodal" /> 
      <TabelaFreteForm ref="tabelafreteform" /> 
    </div>
  </div>
</template>

  <script>
import moment from "moment";
import accounting from "accounting";
import TabelaFreteRotaModal from "./TabelaFreteRotaModal.vue";

import { formatCNPJFromParts } from "../utils";

import TabelaFreteForm from "./TabelaFreteForm.vue"

export default {
  components: {
    TabelaFreteRotaModal,
    TabelaFreteForm
  },
  data() {
    return {
      visibleDetailRowsRota: [],
      visibleDetailRowsVigencia: [],
      vigenciaSelected: [],
      helpForm: new Form({ statusRecord: [], params: [], status: "" }),
      form_vig: new Form({ tabfrerotvig_id: [] }),
      route: []
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onActivateDesactivateTransp(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      console.log("Status");
      console.log(this.helpForm.status);
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.tabfretransp_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }

      this.helpForm
        .patch("/api/tabelafrete/statustransp")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          this.showPopover = true;
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });    
    },
    onAprova(data) {
      if (Array.isArray(data) == false) {
        data = [data];
      }
      if (data.length == 0) {
        this.$snotify.warning(
          "Selecione a(s) vigência(s) que deseja aprovar.",
          "Atenção",
          { timeout: 5000 }
        );
        return;
      }
      this.form_vig.reset();
      let form = this.form_vig;
      var vm = this;
      if (data !== null) {
        var tabfrerotvig_id = data;
      }

      const onConfirmUnitWrapper = () => {
        confirmPresenca(vm, tabfrerotvig_id);
      };

      let confirmPresenca = function(vm, tabfrerotvig_id) {
        vm.form_vig.tabfrerotvig_id = tabfrerotvig_id;
        vm.form_vig
          .post("/api/tabelafretevig/store/aprovacao")
          .then(response => {
            new ReturnApi(response, vm);
          })
          .catch(errors => {
            new ReturnApi(errors, vm);
          });
      };
      let obj = {
        title: "Aprovar?",
        message: "Você deseja aprovar essa(s) vigência(s) ?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper
      };

      this.$Simplert.open(obj);
    },
    onCancela(data) {
      if (Array.isArray(data) == false) {
        data = [data];
      }
      if (data.length == 0) {
        this.$snotify.warning(
          "Selecione a(s) vigência(s) que deseja cancelar.",
          "Atenção",
          { timeout: 5000 }
        );
        return;
      }
      this.form_vig.reset();
      let form = this.form_vig;
      var vm = this;
      if (data !== null) {
        var tabfrerotvig_id = data;
      }

      const onConfirmUnitWrapper = () => {
        confirmPresenca(vm, tabfrerotvig_id);
      };

      let confirmPresenca = function(vm, tabfrerotvig_id) {
        vm.form_vig.tabfrerotvig_id = tabfrerotvig_id;
        vm.form_vig
          .post("/api/tabelafretevig/store/cancelamento")
          .then(response => {
            new ReturnApi(response, vm);
          })
          .catch(errors => {
            new ReturnApi(errors, vm);
          });
      };
      let obj = {
        title: "Cancelar?",
        message: "Você deseja cancelar essa(s) vigência(s) ?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper
      };

      this.$Simplert.open(obj);
    },
    onEditRota(data, index){
      this.route = [];
      this.route.push(index);
      this.$refs.tabelafreteform.onEdit(data, this.route, 1);
    },
    onDetailRota(tabfrerot_id) {
      this.toggleDetailRowRota(tabfrerot_id);
    },
    isVisibleDetailRowRota(rowId) {
      return this.visibleDetailRowsRota.indexOf(rowId) >= 0;
    },
    showDetailRowRota(rowId) {
      if (!this.isVisibleDetailRowRota(rowId)) {
        this.visibleDetailRowsRota.push(rowId);
      }
    },
    hideDetailRowRota(rowId) {
      if (this.isVisibleDetailRowRota(rowId)) {
        this.visibleDetailRowsRota.splice(
          this.visibleDetailRowsRota.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowRota(rowId) {
      if (this.isVisibleDetailRowRota(rowId)) {
        this.hideDetailRowRota(rowId);
      } else {
        this.showDetailRowRota(rowId);
      }
    },
    /////////////////////////////////////////////////////////////
    onDetailVigencia(tabfrerotvig_id) {
      this.toggleDetailRowVigencia(tabfrerotvig_id);
    },
    isVisibleDetailRowVigencia(rowId) {
      return this.visibleDetailRowsVigencia.indexOf(rowId) >= 0;
    },
    showDetailRowVigencia(rowId) {
      if (!this.isVisibleDetailRowVigencia(rowId)) {
        this.visibleDetailRowsVigencia.push(rowId);
      }
    },
    hideDetailRowVigencia(rowId) {
      if (this.isVisibleDetailRowVigencia(rowId)) {
        this.visibleDetailRowsVigencia.splice(
          this.visibleDetailRowsVigencia.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowVigencia(rowId) {
      if (this.isVisibleDetailRowVigencia(rowId)) {
        this.hideDetailRowVigencia(rowId);
      } else {
        this.showDetailRowVigencia(rowId);
      }
    },
    onEditGrupo(data) {
      Event.$emit("editGrupo", data);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, this.casasDecimais, ".", ",");
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    casasDecimais: {
      get() {
        return this.$store.getters.casas_decimais;
      },
    },
  },
};
</script>